import { render } from "./status_history_modal.vue?vue&type=template&id=336f6e67"
import script from "./status_history_modal.js?vue&type=script&lang=js"
export * from "./status_history_modal.js?vue&type=script&lang=js"

import "./status_history_modal.vue?vue&type=style&index=0&id=336f6e67&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__